import { createReactRenderer } from 'helpers/react-renderer';
import { TaxClassForm } from 'root/apps/TaxClassForm/TaxClassForm';

const RenderedComponent = createReactRenderer({
  component: TaxClassForm,
  selector: '[data-react-root="TaxClassForm"]',
});

history.onChangeState(
  [
    {
      name: ['admin.views.class'],
      form_name: 'view',
      tab: 'details',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
